(function() {

    'use strict';

    angular.module('Services').factory('FleetVehiclesTableService', FleetVehiclesTableService);
    FleetVehiclesTableService.$inject = ['$uibModal','$location', 'FleetService', 'TableLiteFactory', 'toastr', 'Units', '$rootScope'];
    function FleetVehiclesTableService($uibModal, $location, FleetService, TableLiteFactory, toastr, Units, $rootScope) {
        return function (options = {}) {
            let measureUnit = Units.getMeasureUnit($rootScope.GlobalProfile.office.measureUnit);
            measureUnit = measureUnit && measureUnit === 'CM' ? 'M' : 'FT';
            const fleetId = angular.getObjVal(options, 'filter') ? angular.getObjVal(options, 'filter')['fleet.id'] || null : null,
                vehicleTypeId = angular.getObjVal(options, 'filter.vehicleTypeId') || null;
            const headers = {
            id: {
                label: 'Vehicle Id',
                viewName: 'vehicleId',
                filterName: 'vehicleId',
                filter: {
                type: 'text',
                    placeholder: 'Search',
                    onSubmit: function(header) {
                    sendRequest(evaluateFilter(header));
                }
            },
                headerFn: function() {
                    sort(this.filterName);
                }
            },
            plateNumber: {
                label: 'Plate Number',
                    viewName: 'plateNumber',
                    filterName: 'plateNumber',
                    filter: {
                    type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                        sendRequest(evaluateFilter(header));
                    },
                    model: '' //optional
                    //text and inputDropdown uses `model` attribute for ng-model
                },
                headerFn: function() {
                    sort(this.filterName);
                }
            },
            type: {
                label: 'Vehicle Type',
                    viewName: 'type',
                    filterName: 'vehicleTypeName',
                    filter: {
                    type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                        sendRequest(evaluateFilter(header));
                    },
                    model: '' //optional
                    //text and inputDropdown uses `model` attribute for ng-model
                },
                headerFn: function() {
                    sort(this.filterName);
                }
            },
            maxWeight: {
                label: 'Max Weight (kg)',
                viewName: 'maxWeight',
                filterName: 'maxWeight',
                /*filter: {
                    type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                        sendRequest(evaluateFilter(header));
                    },
                    model: '' //optional
                    //text and inputDropdown uses `model` attribute for ng-model
                },*/
                headerFn: function() {
                    sort(this.filterName);
                }
            },
            maxVolume: {
                label: `Max Volume (m<sup>3</sup>)`,
                viewName: 'maxVolume',
                filterName: 'maxVolume',
                /*filter: {
                    type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                        sendRequest(evaluateFilter(header));
                    },
                    model: '' //optional
                    //text and inputDropdown uses `model` attribute for ng-model
                },*/
                headerFn: function() {
                    sort(this.filterName);
                }
            },
            status: {
                label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                    type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function(header) {
                        const filter = {};
                        filter[header.filterName] = header.filter.model === 'Active';
                        sendRequest(filter);
                    }
                },
                headerFn: function() {
                    sort(this.filterName);
                }
            }};

            const tableData = {
                tableName: 'FleetVehiclesTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New',
                        tooltip: 'Add New',
                        onClick: options.onAddVehicle || (() => {
                            $location.path('/fleets/vehicles/add').search(angular.extend({}, options.filter));
                        })
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [],
                data: [],
                rowOnClick: options.rowOnClick || (vehicle => {
                    $location.path('/fleets/vehicles/details/' + vehicle.id).search(angular.extend({}, options.filter));
                })
            };
            if(fleetId || vehicleTypeId){
                tableData.optionAddOns.buttons.push({
                    class: 'btn-primary',
                    label: 'Assign existing',
                    tooltip: 'Assign existing vehicle',
                    onClick: (() => {
                        $uibModal.open({
                            animation: true,
                            ariaLabelledBy: 'modal-title',
                            ariaDescribedBy: 'modal-body',
                            templateUrl: '/templates/pages/fleets/modals/vehicleSelect.html',
                            controller: function ($uibModalInstance) {
                                let vm = this;
                                vm.select = select;
                                vm.cancel = cancel;
                                vm.searchVehicle = searchVehicle;

                                function searchVehicle(select) {
                                    if(!select.open)
                                        return false;
                                    vm.searching = true;
                                    vm.vehicles = [];
                                    FleetService.Vehicles.getAll(data=>{
                                        vm.vehicles = data.content.filter(vehicle=>{
                                            if(fleetId){
                                                return angular.getObjVal(vehicle, 'fleet.id') !== fleetId
                                            }
                                            if(vehicleTypeId){
                                                return angular.getObjVal(vehicle, 'vehicleType.id') !== vehicleTypeId;
                                            }
                                        });
                                        vm.searching = false;
                                    }, error=> {
                                        vm.searching = true;
                                        toastr.error('Unable to search for vehicle', error.message);
                                    }, {
                                        plateNumber: select.search,
                                        hasDriver: false,
                                        size: 40
                                    })
                                }

                                function select() {
                                    FleetService.Vehicles.update(vm.vehicle.id, cleanPayload(vm.vehicle),function () {
                                        $uibModalInstance.close();
                                    }, function () {
                                        toastr.error('Please try again later', 'Unable to assign vehicle');
                                        $uibModalInstance.dismiss();
                                    });
                                }

                                function cancel() {
                                    $uibModalInstance.dismiss();
                                }
                            },
                            controllerAs: 'vm',
                            size: 'md',
                            appendTo: $('body')
                        }).result.then(()=>{
                            sendRequest();
                        });
                    })
                });
            }
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: FleetService.Vehicles.getAll,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }, options.filter || {})
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if(!data)
                    return null;
                angular.forEach(data.content, function(vehicle, index) {
                    vehicle.status = {
                        type: 'status',
                        status: vehicle.active,
                        label: vehicle.active ? 'Active' : 'Inactive'
                    };
                    vehicle.type = vehicle.vehicleType.name;
                    vehicle.maxVolume = `${(vehicle.maxLength / 100) * (vehicle.maxWidth / 100) * (vehicle.maxHeight / 100)} ${measureUnit}<sup>3</sup>`;
                    tableData.data.push(vehicle);
                });
                /*** END - Building of Data ***/
            }
            (()=>{
                for(let key in headers){
                    if(angular.getObjVal(options, 'exclude.length')){
                        options.exclude.forEach(head=>{
                            if(head !== key){
                                tableData.headers.push(headers[key]);
                            }
                        })
                    }else{
                        tableData.headers.push(headers[key]);
                    }
                }
            })();

            function cleanPayload(payload) {
                let {
                    active,
                    assistantOnBoard,
                    color,
                    driverId,
                    equippedWithTrolley,
                    fleet,
                    make,
                    maxHeight,
                    maxLength,
                    //maxVolume,
                    maxWeight,
                    maxWidth,
                    minHeight,
                    minLength,
                    minWeight,
                    minWidth,
                    model,
                    owner,
                    plateNumber,
                    plateNumberPhotoUrl,
                    vehiclePhotoUrl,
                    vehicleId,
                    vehicleType,
                    year,
                } = payload;
                return {
                    active,
                    assistantOnBoard,
                    color,
                    driverId,
                    equippedWithTrolley,
                    fleetId: fleetId || angular.getObjVal(fleet, 'id'),
                    make,
                    maxHeight: maxHeight * 100,
                    maxLength: maxLength * 100,
                    //maxVolume: maxVolume * 100,
                    maxWeight,
                    maxWidth: maxWidth * 100,
                    minHeight: minHeight * 100,
                    minLength: minLength * 100,
                    minWeight,
                    minWidth: minWidth * 100,
                    model,
                    owner,
                    plateNumber,
                    plateNumberPhotoUrl,
                    vehiclePhotoUrl,
                    vehicleId,
                    vehicleTypeId: vehicleTypeId || angular.getObjVal(vehicleType, 'id'),
                    year
                }
            }
            this.tableData = tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/FleetVehiclesTableService.js